import { defineComponent } from 'vue'
export default defineComponent ({
    name: 'Tables'
    , props: {
        fields: {
            type: Array
            , required: false
            , default: () => ([])
        }
        , items: {
            type: Array
            , required: false
            , default: () => ([])
        }
    }
})